import * as React from "react";
import {useState, useEffect, MouseEventHandler} from 'react';
import { jfetch, toast } from "../../utils";
import PageContainer from "../core/PageContainer";
import ModernCard from "../core/ModernCard";
import Breadcrumbs from "../core/Breadcrumbs";
import Button from "../core/Button";
import IconPicker from "../core/IconPicker"
import { useParams, useHistory } from "react-router-dom";
import Select, { components } from "react-select-new";
import Swal from 'sweetalert2'
import {SortableContainer, SortableElement, SortableHandle} from 'react-sortable-hoc';
import Test from "./Test"

interface IProps {
  userContext:any;
}

function QuoteCalculatorEdit(props:IProps){
  // const [defaults, setDefaults] = useState({services:[], products:[], charges:[], project_services:[]})
  const [name, setName] = useState('')
  const [icon, setIcon] = useState('')
  const [org, setOrg] = useState('')
  const [orgs, setOrgs] = useState([])
  const [global, setGlobal] = useState(false)
  const [services, setServices] = useState([])
  const [myServices, setMyServices] = useState([])
  const [products, setProducts] = useState([])
  const [myProducts, setMyProducts] = useState([])
  const [charges, setCharges] = useState([])
  const [myCharges, setMyCharges] = useState([])
  const [projectServices, setProjectServices] = useState([])
  const [myProjectServices, setMyProjectServices] = useState([])
  const {calculator_id}:any = useParams()
  const is_admin = props.userContext.user.roles.includes("company_admin")
  const event = new Event('quote_change');
  let history = useHistory()


  useEffect(() => {
    jfetch
    .get(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}`)
    .then((resp) => {
      setName(resp.calculator.name)
      setIcon(resp.calculator.icon)
      setGlobal(resp.calculator.global == true)
    })
    jfetch
    .get(`/organizations/${props.userContext.org.idd}/quote_calculator/quote_calculator/${calculator_id}/options`)
    .then((resp) => {
      setServices(resp.all_services)
      setMyServices(resp.my_services)
      setProducts(resp.all_products)
      setMyProducts(resp.my_products)
      setCharges(resp.all_charges)
      setMyCharges(resp.my_charges)
      setProjectServices(resp.all_project_services)
      setMyProjectServices(resp.my_project_services)

    }) 
    if(is_admin){
      jfetch
      .get('/organizations/search?page=1&per=12000')  
      .then((resp) => {
        setOrgs(resp.organizations.data)
      }) 
    }
  }, [])


  useEffect(() => {
    window.document.dispatchEvent(event);
  }, [])  

  function cloneIt(){
    if(org != ''){
      jfetch
      .get(`/organizations/${org}/quote_calculator/quote_calculator/${calculator_id}/clone`, {
        organization_id: org
      })
      .then((resp) => {
        toast.success('Calculator was Cloned')
      })
      .catch(() => {
        toast.error('Error Saving')
      })
    }
    else{
      toast.error('please select an org')
    }
  }

  function arrayMove(array, from, to) {
    array = array.slice();
    array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
    return array;
  }

  const SortableMultiValue = SortableElement((props) => {
    // this prevents the menu from being opened/closed when the user clicks
    // on a value to begin dragging it. ideally, detecting a click (instead of
    // a drag) would still focus the control and toggle the menu, but that
    // requires some magic with refs that are out of scope for this example
    const onMouseDown = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
    const innerProps = { ...props.innerProps, onMouseDown };
    return <components.MultiValue {...props} innerProps={innerProps} />;
  });

  const SortableMultiValueLabel = SortableHandle((props) => (
    <components.MultiValueLabel {...props} />
  ));

  const SortableSelect:any = SortableContainer(Select);


  const onSortEnd = ({oldIndex, newIndex}, array, updateArray) => {
    const newValue = arrayMove(array, oldIndex, newIndex);
    updateArray(newValue);
    // console.log(
    //   "Values sorted:",
    //   newValue.map((i) => i.value)
    // );
  };

  return (
    <PageContainer>   
      <Breadcrumbs
        crumbs={[
          {
            label: "Pricing Quote Dashboard",
            route: "/quote_calculator",
            routerLink: true,
          },
          { label: "Edit Calculator" },
        ]}
      />
      <div className="quote-calc-new-root">
        <div className="row">
          <div className="col-lg-12 text-right">
            <Button 
              color="danger"
              onClick={() => {
                Swal.fire({
                  title: '<h3 style="font-size:24px;">Are you sure?  <br/> All Quotes from this calculator will also be deleted<h3>',
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  customClass: { confirmButton: 'btn btn-primary btn-small', closeButton: 'btn btn-danger btn-small'},
                  confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                  if (result.value) {
                    jfetch
                    .delete(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}`)
                    .then((resp) => {
                      history.push('/quote_calculator')
                      toast.success('Calculator and Quotes Were Deleted.')
                    })
                  }
                })
              }}              
            >
              Delete Calculator
            </Button>
          </div>
          <div className="col-lg-12">
            <ModernCard ta="left">
              <div className="row"> 
                <div className="col-lg-6">
                  <div className="form-group">
                    <h3>Calculator Name</h3>
                    <input 
                      value={name}
                      type="text" 
                      className="form-control"
                      onChange={(e) => setName(e.target.value)} 
                    />
                  </div>
                  <IconPicker icon={icon} updateIcon={(i) => setIcon(i)} /> 
                  {is_admin && <GlobalButton global={global} updateGlobal={(val) => setGlobal(val)} />}
                  {is_admin && (
                    <div className="form-group">
                      <h3>Clone to another Organization</h3>
                      <select value={org} onChange={(e) => setOrg(e.target.value)} style={{all:'revert'}}>
                        <option value="">Select Org..</option>
                        {orgs.map((org) => <option value={org.attributes.id} key={org.attributes.id}>{org.attributes.title}</option>)}
                      </select>
                      <br/>
                      <button onClick={cloneIt} className="btn btn-info" style={{marginTop:'15px'}}>Clone</button> 
                    </div>                  
                  )}
                </div>
              </div>
              <div className="row" style={{paddingTop:'30px'}}> 
                <div className="col-lg-12">
                  <Button type="button" href={`/quote_calculator/order/${calculator_id}`} color="primary" >Order Items</Button>
                </div>
              </div>          
            </ModernCard>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <ModernCard ta="left">
              {/* <div>
                <Test/>
              </div> */}
              <h3>Monthly Support Services</h3>
              <div style={{minHeight:'400px', overflow:'scroll'}}>
                <SortableSelect
                  useDragHandle
                  // react-sortable-hoc props:
                  axis="xy"
                  onSortEnd={(ev) => onSortEnd(ev, myServices, setMyServices)}
                  distance={2}
                  // small fix for https://github.com/clauderic/react-sortable-hoc/pull/352:
                  getHelperDimensions={({ node }) => node.getBoundingClientRect()}
                  // react-select props:
                  isMulti
                  options={services}
                  value={myServices}
                  onChange={(selected) => setMyServices(selected)}
                  components={{
                    MultiValue: SortableMultiValue,
                    MultiValueLabel: SortableMultiValueLabel
                  }}
                  classNamePrefix="qc_react_select"
                  closeMenuOnSelect={false}
                />
              </div>
            </ModernCard>
          </div>
        </div> 
        <div className="row">
          <div className="col-lg-12">
            <ModernCard ta="left">
              <h3>Monthly Products</h3>
              <div style={{minHeight:'400px', overflow:'scroll'}}>
                <SortableSelect
                  useDragHandle
                  // react-sortable-hoc props:
                  axis="xy"
                  onSortEnd={(ev) => onSortEnd(ev, myProducts, setMyProducts)}
                  distance={4}
                  // small fix for https://github.com/clauderic/react-sortable-hoc/pull/352:
                  getHelperDimensions={({ node }) => node.getBoundingClientRect()}
                  // react-select props:
                  isMulti
                  options={products}
                  value={myProducts}
                  onChange={(selected) => setMyProducts(selected)}
                  components={{
                    MultiValue: SortableMultiValue,
                    MultiValueLabel: SortableMultiValueLabel
                  }}
                  classNamePrefix="qc_react_select"
                  closeMenuOnSelect={false}
                />
              </div>
            </ModernCard>
          </div>
        </div> 
        <div className="row">
          <div className="col-lg-12">
            <ModernCard ta="left">
              <h3>One-Time Purchase/HaaS Product</h3>
              <div style={{minHeight:'400px', overflow:'scroll'}}>
                <SortableSelect
                  useDragHandle
                  // react-sortable-hoc props:
                  axis="xy"
                  onSortEnd={(ev) => onSortEnd(ev, myCharges, setMyCharges)}
                  distance={4}
                  // small fix for https://github.com/clauderic/react-sortable-hoc/pull/352:
                  getHelperDimensions={({ node }) => node.getBoundingClientRect()}
                  // react-select props:
                  isMulti
                  options={charges}
                  value={myCharges}
                  onChange={(selected) => setMyCharges(selected)}
                  components={{
                    MultiValue: SortableMultiValue,
                    MultiValueLabel: SortableMultiValueLabel
                  }}
                  classNamePrefix="qc_react_select"
                  closeMenuOnSelect={false}
                />
              </div>
            </ModernCard>
          </div>
        </div> 
        <div className="row">
          <div className="col-lg-12">
            <ModernCard ta="left">
              <h3>Project Labor</h3>
              <div style={{minHeight:'400px', overflow:'scroll'}}>
                <SortableSelect
                  useDragHandle
                  // react-sortable-hoc props:
                  axis="xy"
                  onSortEnd={(ev) => onSortEnd(ev, projectServices, setProjectServices)}
                  distance={4}
                  // small fix for https://github.com/clauderic/react-sortable-hoc/pull/352:
                  getHelperDimensions={({ node }) => node.getBoundingClientRect()}
                  // react-select props:
                  isMulti
                  options={projectServices}
                  value={myProjectServices}
                  onChange={(selected) => setMyProjectServices(selected)}
                  components={{
                    MultiValue: SortableMultiValue,
                    MultiValueLabel: SortableMultiValueLabel
                  }}
                  classNamePrefix="qc_react_select"
                  closeMenuOnSelect={false}
                /> 
              </div>   
            </ModernCard>
          </div>
        </div>           
        <div className="row" style={{paddingTop:'15px', paddingBottom:'15px'}}>
          <div className="col-lg-12 text-right">
            <Button 
              color="primary"
              onClick={() => {
                jfetch.put(`/organizations/${props.userContext.org.id}/quote_calculator/quote_calculator/${calculator_id}`, {
                  name: name,
                  icon: icon,
                  global: global,
                  services: myServices,
                  products: myProducts,
                  charges: myCharges,
                  project_services: myProjectServices
                })
                .then((resp) => {
                  toast.success('Calculator Was Updated!');
                })
              }}
            >
              Update
            </Button>
          </div>
        </div>
      </div>          
    </PageContainer>
  )
}

interface GBProps{
  global:boolean;
  updateGlobal:Function;
}
function GlobalButton(props:GBProps){
  const [global, setGlobal] = useState(props.global);
  const [buttonColor, setButtonColor] = useState('')
  const [buttonText, setButtonText] = useState('')
  useEffect(() => {
    setGlobal(props.global)
  }, [props.global])

  useEffect(() => {
    set_original()
  }, [global])

  function set_original(){
    global ? setButtonColor('btn btn-primary') : setButtonColor('btn btn-default');
    global ? setButtonText('Global Calculator') : setButtonText('Organization Only Calculator')
  }

  function set_hover(){
    global ? setButtonColor('btn btn-default') : setButtonColor('btn btn-primary');
    global ? setButtonText('Remove Global') : setButtonText('Make Global')
  }

  return (
    <div className="form-group">
      <h3>Global</h3>
      <button className={buttonColor} onMouseEnter={() => set_hover()} onMouseLeave={() => set_original()} onClick={() => props.updateGlobal(!props.global)} style={{minWidth:'250px', textAlign:'center'}}>
        {buttonText}
      </button>
    </div>
  )
}

export default QuoteCalculatorEdit;


// WEBPACK FOOTER //
// ./app/javascript/components/quote_calculator/QuoteCalculatorEdit.tsx